import { generateDayFromNowTo } from 'libs/helpers';

export const isNotifBlocked = '_hasBlocknotif';
export const isSubscribeCT = '_hasSubscribeCT';
export const notifCookiesExpires = (days = 7) => generateDayFromNowTo(days);
